import { createRouter, createWebHistory } from "vue-router";

import routes from "./paths";
// import i18n from "@/plugins/i18n.js";
// import { DEFAULT_LOCALE } from "@/config/variables.js";

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  base: process.env.BASE_URL,
  routes,
});

router.beforeEach((to, from, next) => {
  // document.title = to.meta.title;
  // console.log("from:", from);
  // console.log("to:", to);
  // const languages = i18n?.global?.messages
  //   ? Object.keys(i18n.global.messages)
  //   : [];
  // if (
  //   to.params.locale &&
  //   (!languages.includes(to.params.locale) ||
  //     to.params.locale === DEFAULT_LOCALE)
  // ) {
  //   next({ name: to.name });
  //   return;
  // }
  next();
});

export default router;
